import React, { useState, useEffect } from "react";
import useTableFijo from "../../useTableFijo";
import moment from "moment";

const headCells = [
  {
    id: "numfactura",
    label: "Nº FACTURA",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
  {
    id: "periodo",
    label: "PERIODO",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
  {
    id: "documento",
    label: "Nº DOCUMENTO",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
  {
    id: "tipo",
    label: "TIPO",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
  {
    id: "banco",
    label: "BANCO",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
  {
    id: "fechaemision",
    label: "FECHA",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
  {
    id: "monto",
    label: "MONTO",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
  {
    id: "status",
    label: "STATUS",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
];

const TablaFacturasContribuyente = (props) => {
  const [records, setRecords] = useState([]);
  const [filterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const { TblContainer, TblHead } = useTableFijo(
    records,
    headCells,
    filterFn,
    320,
  );

  useEffect(() => {
    if (props.tabfacC) {
      console.log(props.tabfacC);

      setRecords(props.tabfacC);
    }
  }, [props.tabfacC]);
  return (
    <div className="col-12 m-0 mt-2 p-0">
      <TblContainer
        container={{
          height: 250,
          width: "100%",
          overflow: "auto",
          padding: "2px",
        }}
      >
        <TblHead />

        <tbody>
          {records &&
            records.map((item, index) => (
              <tr key={index} style={{ padding: "0" }}>
                <td style={{ fontSize: "10px", textAlign: "center", width: 'auto' }}>
                  {item.factura}
                </td>
                <td style={{ fontSize: "10px", textAlign: "center", width: 'auto' }}>
                  {item.peri}
                </td>
                <td style={{ fontSize: "10px", textAlign: "center", width: 'auto'}}>
                  {item.numerodocumento}
                </td>
                <td style={{ fontSize: "10px", textAlign: "left", width: 'auto' }}>
                  {item.tipotransaccion === '2' ? "TRASFERENCIA": "DEPOSITO"}
                </td>
                <td style={{ fontSize: "10px", textAlign: "left", width: 'auto' }}>
                  {item.cta}
                </td>
                <td style={{ fontSize: "10px", textAlign: "center", width: 'auto' }}>
                  {item.fecha}
                </td>
                <td style={{ fontSize: "10px", textAlign: "center", width: 'auto' }}>
                  {item.monto}
                </td>
                <td style={{ fontSize: "10px", textAlign: "center", width: 'auto' }}>
                  {item.estatus}
                </td>
              </tr>
            ))}
        </tbody>
      </TblContainer>
    </div>
  );
};
export default TablaFacturasContribuyente;
